import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import ArticleRenderer from '@/components/feature/ArticleRenderer';
import { basetaoShippingCost } from '@/mocks/basetao-shipping-cost';

export default function BasetaoShippingCostGuide() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <ArticleRenderer
        content={basetaoShippingCost}
        breadcrumbLabel="Basetao Shipping Cost Guide"
        headerImage="https://readdy.ai/api/search-image?query=Modern%20minimalist%20shipping%20and%20logistics%20concept%20with%20cardboard%20boxes%20on%20warm%20wooden%20surface%2C%20soft%20natural%20lighting%2C%20cream%20and%20terracotta%20color%20palette%2C%20clean%20aesthetic%2C%20editorial%20product%20photography%2C%20gentle%20shadows%2C%20elegant%20composition&width=1200&height=400&seq=btsc-header-2026&orientation=landscape"
        articleSlug="/article/basetao-shipping-cost-guide"
      />
      <section className="py-12 md:py-16 bg-background-100 border-t border-background-200/60">
        <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
          <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-3">
            Calculate Your Basetao Shipping Costs
          </h3>
          <p className="text-foreground-600 text-sm md:text-base mb-6">
            Use the Basetao Spreadsheet shipping calculator to estimate costs before ordering.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-white font-semibold rounded-md hover:bg-primary-600 transition-all text-sm whitespace-nowrap">
              Visit Basetao Spreadsheet
            </a>
            <Link to="/" className="w-full sm:w-auto px-8 py-3 bg-foreground-900 text-white font-semibold rounded-md hover:bg-foreground-800 transition-all text-sm whitespace-nowrap">
              Back to Home
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}